import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { QueryClient } from '@tanstack/react-query';
import { TAuthInitialData } from '@/context/authContext';

interface RouterContext {
  queryClient: QueryClient;
  auth: TAuthInitialData;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
